
import React, { Component } from "react";
// react component used to create charts
import SweetAlert from "react-bootstrap-sweetalert";

import Button from "../../../components/CustomButton/CustomButton.jsx";
import rest from "../../../API/api";
import PropTypes from "prop-types";

// Import the stripe react components
//import {CardElement, StripeProvider, Elements} from "react-stripe-elements";
import Card from 'react-credit-cards';

//import SupportedCards from '../../../Utils/CCCards';

import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
    formatFormData,
} from '../../../utils/utils';
//import '../../../Utils/CCstyles.css';

//import 'react-credit-cards/es/styles-compiled.css';
import 'react-credit-cards/lib/styles.scss';
import {Col, ControlLabel, FormControl, FormGroup, Row} from "react-bootstrap";
import Checkbox from "../../../components/CustomCheckbox/CustomCheckbox";
import TCPDF from "../../../documents/TRO-subscription-website-terms-and-conditions.pdf";
import ReactDOM from "react-dom";
import Payment from "payment";

class Step3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
        number: '',
        name: '',
        expiry: '',
        cvc: '',
        zip: '',
        issuer: '',
        focused: '',
        agree: false,
        formData: null,
        numberError: null,
        nameError: null,
        expiryError: null,
        cvcError: null,
        zipError: null,
        agreeError: null,
        issuerError: null,
        focusedError: null,
        formDataError: null,
      alert: null
    };
    this.saveRegistration = this.saveRegistration.bind(this);
    this.handleAgreeCheckbox = this.handleAgreeCheckbox.bind(this);
  }

    handleCallback = ({ issuer }, isValid) => {
        if (isValid) {
            this.setState({ issuer });
        }
    };

    handleInputFocus = ({ target }) => {
        this.setState({
            focused: target.name,
        });
    };

    handleInputChange = ({ target }) => {
        if (target.name === 'number') {
            target.value = formatCreditCardNumber(target.value);
        } else if (target.name === 'expiry') {
            target.value = formatExpirationDate(target.value);
        } else if (target.name === 'cvc') {
            target.value = formatCVC(target.value);
        }

        this.setState({ [target.name]: target.value });
    };

    handleSubmit = e => {
        e.preventDefault();
        const { issuer } = this.state;
        const formData = [...e.target.elements]
            .filter(d => d.name)
            .reduce((acc, d) => {
                acc[d.name] = d.value;
                return acc;
            }, {});

        this.setState({ formData });
        this.form.reset();
    };

  static get contextTypes() {
      return {
          router: PropTypes.object
      };
  }

/*
  onConfirm={() => this.context.router.history.push("/Home")}
  onCancel={() => this.context.router.history.push("/Home")}
*/

    successAlert(success){
        //Setup the alert and use the context to route to the home page once logged in.
        if(success) {
            this.setState({
                alert: (
                    <SweetAlert
                        success
                        title="Thank you for signing up!"
                        style={{display: "block"}}

                        onConfirm={() => this.context.router.history.push("/Home")}
                        onCancel={() => this.context.router.history.push("/Home")}
                        confirmBtnBsStyle="info"
                    >
                        Watch for an email notifying you that your subscription is active!
                    </SweetAlert>
                )
            });
        }
        else
        {
            this.setState({
                alert: (
                    <SweetAlert
                        danger
                        style={{display: "block"}}
                        title="Opps! Something went wrong!"
                        onConfirm={() => this.setState({alert: null})}
                        onCancel={() => this.setState({alert: null})}
                        confirmBtnBsStyle="danger"
                    >
                        Sorry we had an issue signing you up, please try again!
                    </SweetAlert>
                )
            });
        }
    }

    saveRegistration(event) {
        event.preventDefault();
        if(this.isValidated()) {
            //lets calculate the user and Kiosk hashes and salts
            var crypto = require('crypto');
            //assign the Salt, generate the hash based on the password provided
            let myuseridSalt = crypto.randomBytes(16).toString('hex');
            let myuseridHash = crypto.pbkdf2Sync(this.props.getStore().Password, myuseridSalt, 1000, 64, 'sha512').toString('hex');
            let mykioskidSalt = crypto.randomBytes(16).toString('hex');
            let mykioskidHash = crypto.pbkdf2Sync(this.props.getStore().KioskPassword, mykioskidSalt, 1000, 64, 'sha512').toString('hex');

            fetch(rest.register, {
                headers: new Headers({
                    'Content-Type': 'application/json;charset=UTF-8',
                    'x-api-key': rest.apiKey
                }),
                method: 'POST',

                body: JSON.stringify({
                    RequestingTenantId: "N/A",
                    EventType: "Register",
                    Userid: this.props.getStore().Userid,
                    Kioskid: this.props.getStore().Kioskid,
                    Email: this.props.getStore().email,
                    Company: this.props.getStore().company,
                    Fname: this.props.getStore().firstname,
                    Lname: this.props.getStore().lastname,
                    Address: this.props.getStore().address,
                    City: this.props.getStore().city,
                    State: this.props.getStore().state,
                    Country: this.props.getStore().country,
                    Postal: this.props.getStore().zip,
                    Phone: this.props.getStore().phone,
                    SubscriptionDate: this.props.getStore().SubscriptionDate,
                    SubscriptionStatus: false,
                    SubscriptionType: this.props.getStore().SubscriptionType,
                    SubscriptionPrice: this.props.getStore().SubscriptionPrice,
                    SubscriptionMultiShopCount: this.props.getStore().SubscriptionMultiShopCount,
                    CustomerXRef: "",
                    UserHash: myuseridHash,
                    UserSalt: myuseridSalt,
                    KioskHash: mykioskidHash,
                    KioskSalt: mykioskidSalt,
                    CCNumber: this.state.number,
                    CCName: this.state.name,
                    CCExpiry: this.state.expiry,
                    CCCvc: this.state.cvc,
                    CCZip: this.state.zip,
                    CCIssuer: Payment.fns.cardType(this.state.number),
                    Processed: false,
                    Notes: ""
                })
            })
                .then(response => response.json())
                .then(data => {
                    //Lets send an email to our admin account for notification that a registration is waiting
                    var message = '<html><body>';
                    message = message + "<h2> You have a new Registration Request generated from our Website:</h2><br><br>"
                    //message = message + '<img src="//css-tricks.com/examples/WebsiteChangeRequestForm/images/wcrf-header.png" alt="Website Change Request" />';
                    message = message + '<table rules="all" style="border-color: #666;" cellpadding="10">';
                    message = message + "<tr style='background: #eee;'><td><strong>" + "New Subscription Request" + "</strong> </td><td>" + "Details" + "</td></tr>";
                    message = message + "<tr><td><strong>Customer Name:</strong> </td><td>" + this.props.getStore().firstname + " " + this.props.getStore().lastname + "</td></tr>";
                    message = message + "<tr><td><strong>Customer Phone Number:</strong> </td><td>" + this.props.getStore().phone + "</td></tr>";
                    message = message + "<tr><td><strong>Customer Email:</strong> </td><td>" + this.props.getStore().email + "</td></tr>";
                    message = message + "<tr><td><strong>Customer Address:</strong> </td><td>" + this.props.getStore().address + "</td></tr>";
                    message = message + "<tr><td><strong>Customer City:</strong> </td><td>" + this.props.getStore().city + "</td></tr>";
                    message = message + "<tr><td><strong>Customer State:</strong> </td><td>" + this.props.getStore().state + "</td></tr>";
                    message = message + "<tr><td><strong>Customer Zip Code:</strong> </td><td>" + this.props.getStore().zip + "</td></tr>";
                    message = message + "<tr><td><strong>Customer Country:</strong> </td><td>" + this.props.getStore().country + "</td></tr>";
                    message = message + "<tr><td><strong>Subscription Plan:</strong> </td><td>" + this.props.getStore().SubscriptionType + "</td></tr>";
                    message = message + "<tr><td><strong>Multi-Shop Count:</strong> </td><td>" + this.props.getStore().SubscriptionMultiShopCount + "</td></tr>";
                    message = message + "<tr><td><strong>Subscription Price:</strong> </td><td>" + "$" + this.props.getStore().SubscriptionPrice + "</td></tr>";
                    message = message + "<tr><td><strong>Subscription Next Invoice Date:</strong> </td><td>" + this.props.getStore().SubscriptionDate + "</td></tr>";
                    message = message + "</table>";
                    message = message + "</body></html>";
                    fetch(rest.sendmail, {
                        headers: new Headers({
                            'Content-Type': 'application/json;charset=UTF-8',
                            'x-api-key': rest.apiKey
                        }),
                        method: 'POST',

                        body: JSON.stringify({
                            to: rest.email,
                            from: rest.email,
                            subject: "New Registration Request",
                            message: message
                        })
                    })
                        .then(response => response.json())
                        .then(data => {
                            this.successAlert(true);
                        })
                        .catch(error => console.error(error));

                    this.successAlert(true);
                })
                .catch(error => console.error(error));
        }

    }

    isValidated() {
        const userInput = this._grabUserInput(); // grab user entered vals
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var regex_cardnumber,cardnumberlength;
        var regex_zipcode = /\d{5}/;
        //Set the correct reg expression based on card issuer
        const issuer = Payment.fns.cardType(this.state.number);
        switch(issuer){
            case "amex":
                regex_cardnumber = /[\d| ]{17}/;
                cardnumberlength = 17;
                break;
            case "dinersclub":
                regex_cardnumber = /[\d| ]{16}/;
                cardnumberlength = 16;
                break;
            default:
                regex_cardnumber = /[\d| ]{19}/;
                cardnumberlength=19;
                break;

        }
        var regex_expiry=/^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/;
        var regex_cvc=/\d{3,4}/;
        ((regex_cardnumber.test(this.state.number) === false)||(this.state.number.length > cardnumberlength))
            ? this.setState({
                numberError: (
                    <small className="text-danger">
                       Please provide the complete Credit Card Number.
                    </small>
                )
            })
            : this.setState({ numberError: null });

        //check each required field for validation
        this.state.name === ""
            ? this.setState({
                nameError: (
                    <small className="text-danger">
                        Please provide the name on the credit card.
                    </small>
                )
            })
            : this.setState({ nameError: null });
        var name = this.state.name !== "";

        var today, someday;
        var exMonth=this.state.expiry.slice(0,2);
        //Works for the next 80 years :)
        var exYear="20" + this.state.expiry.slice(3);
        today = new Date();
        someday = new Date();
        someday.setFullYear(exYear, exMonth, 1);

        ((regex_expiry.test(this.state.expiry) === false) || (someday < today))
            ? this.setState({
                expiryError: (
                    <small className="text-danger">
                        Please provide the complete expiration date.
                    </small>
                )
            })
            : this.setState({ expiryError: null });

        regex_cvc.test(this.state.cvc) === false
            ? this.setState({
                cvcError: (
                    <small className="text-danger">
                        Please provide the Security Code.
                    </small>
                )
            })
            : this.setState({ cvcError: null });

        ((regex_zipcode.test(this.state.zip) === false)||(this.state.zip.length !== 5))
            ? this.setState({
                zipError: (
                    <small className="text-danger">
                        Please provide a valid zip code.
                    </small>
                )
            })
            : this.setState({ zipError: null });

        (this.state.agree === false)
            ? this.setState({
                agreeError: (
                    <small className="text-danger">
                        Please Acknowledge that you agree to our T&Cs
                    </small>
                )
            })
            : this.setState({ agreeError: null });
        var agree = this.state.agree !== false;

        var valid = (regex_cardnumber.test(this.state.number) && name && regex_expiry.test(this.state.expiry)
            && regex_cvc.test(this.state.cvc) && regex_zipcode.test(this.state.zip) && agree && (someday > today) );
        if(valid)
            this.props.updateStore({
                ...userInput,
                sentEmail: false // use this to notify step4 that some changes took place and prompt the user to save again
            });
        return valid;
    }

    _grabUserInput() {
        return {
            number: document.getElementById('number').value,
            name: document.getElementById('name').value,
            expiry: document.getElementById('expiry').value,
            cvc: document.getElementById('cvc').value,
            zip: document.getElementById('zip').value,
            agree: document.getElementById("agree").checked
        };
    }

    handleAgreeCheckbox = () => {
        this.setState({
            agree: !this.state.agree,
        });
    };

  render() {
      const { name, number, expiry, cvc, focused, issuer, formData } = this.state;

    return (
      <div className="wizard-step">

              <div className="App-payment">
                  <Card
                      number={this.state.number}
                      name={this.state.name}
                      expiry={this.state.expiry}
                      cvc={this.state.cvc}
                      focused={this.state.focused}
                      callback={this.handleCallback}

                  />
              </div>
              <Row>
                  <Col md={6} mdOffset={3}>
                      <FormGroup>
                          <ControlLabel>Credit Card Number <span className="text-danger">*</span></ControlLabel>
                          {(this.state.numberError === null) ? (
                              <FormControl
                                  className="valid"
                                  id="number"
                                  type="tel"
                                  name="number"
                                  maxLength="19"
                                  placeholder="Card Number E.g.: 49..., 51..., 36..., 37..."
                                  value={this.state.number}
                                  pattern="[\d| ]{16,22}"
                                  onChange={this.handleInputChange}
                                  onFocus={this.handleInputFocus}
                              />
                              ) : (
                              <FormControl
                                  className="error"
                                  id="number"
                                  type="tel"
                                  name="number"
                                  maxlength="19"
                                  placeholder="Card Number E.g.: 49..., 51..., 36..., 37..."
                                  value={this.state.number}
                                  pattern="[\d| ]{16,22}"
                                  onChange={this.handleInputChange}
                                  onFocus={this.handleInputFocus}
                              />
                          )}
                          {this.state.numberError}
                      </FormGroup>
                  </Col>
              </Row>
              <Row>
                  <Col md={6} mdOffset={3}>
                      <FormGroup>
                          <ControlLabel>Name on Credit Card <span className="text-danger">*</span></ControlLabel>
                          {(this.state.nameError === null) ? (
                              <FormControl
                                  className="valid"
                                  id="name"
                                  type="text"
                                  name="name"
                                  placeholder="Name on Card"
                                  value={this.state.name}
                                  onChange={this.handleInputChange}
                                  onFocus={this.handleInputFocus}
                              />
                              ) : (
                              <FormControl
                                  className="error"
                                  id="name"
                                  type="text"
                                  name="name"
                                  placeholder="Name on Card"
                                  value={this.state.name}
                                  onChange={this.handleInputChange}
                                  onFocus={this.handleInputFocus}
                              />
                          )}
                          {this.state.nameError}
                      </FormGroup>
                  </Col>
              </Row>
          <Row>
              <Col md={2} mdOffset={3}>
                  <FormGroup>
                      <ControlLabel>Expiration <span className="text-danger">*</span></ControlLabel>
                      {(this.state.expiryError === null) ? (
                          <FormControl
                              className="valid"
                              id="expiry"
                              type="tel"
                              name="expiry"
                              placeholder="Valid Thru"
                              value={this.state.expiry}
                              pattern="\d\d/\d\d"
                              onChange={this.handleInputChange}
                              onFocus={this.handleInputFocus}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="expiry"
                              type="tel"
                              name="expiry"
                              placeholder="Valid Thru"
                              value={this.state.expiry}
                              pattern="\d\d/\d\d"
                              onChange={this.handleInputChange}
                              onFocus={this.handleInputFocus}
                          />
                      )}
                      {this.state.expiryError}
                  </FormGroup>
              </Col>
              <Col md={2} >
                  <FormGroup>
                      <ControlLabel>CVC <span className="text-danger">*</span></ControlLabel>
                      {(this.state.cvcError === null) ? (
                          <FormControl
                              className="valid"
                              id="cvc"
                              type="tel"
                              name="cvc"
                              placeholder="CVC"
                              value={this.state.cvc}
                              pattern="\d{3,4}"
                              onChange={this.handleInputChange}
                              onFocus={this.handleInputFocus}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="cvc"
                              type="tel"
                              name="cvc"
                              placeholder="CVC"
                              value={this.state.cvc}
                              pattern="\d{3,4}"
                              onChange={this.handleInputChange}
                              onFocus={this.handleInputFocus}
                          />
                      )}
                      {this.state.cvcError}
                  </FormGroup>
              </Col>
              <Col md={2}>
                  <FormGroup>
                      <ControlLabel>Zip Code <span className="text-danger">*</span></ControlLabel>
                      {(this.state.zipError === null) ? (
                          <FormControl
                              className="valid"
                              id="zip"
                              type="tel"
                              name="zip"
                              defaultValue={this.state.zip}
                              placeholder="ex: 80107"
                              value={this.state.zip}
                              pattern="\d{5}"
                              onChange={event => this.setState({ zip: event.target.value })}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="zip"
                              type="text"
                              name="zip"
                              defaultValue={this.state.zip}
                              placeholder="ex: 80107"
                              value={this.state.zip}
                              pattern="\d{5}"
                              onChange={event => this.setState({ zip: event.target.value })}
                          />
                      )}
                      {this.state.zipError}
                  </FormGroup>
              </Col>
          </Row>
          <Row>
              <Col md={8} mdOffset={3}>
                  <hr />
                  <h6>All users of Tattoo Release Online (TRO) software are required to review, agree to, and abide by our software
                      terms and conditions provided from this link: <a href = {TCPDF} target = "_blank">Download our Terms and Conditions</a>.
                      Failure to do so can result in termination of your subscription and/or interruption of our service with you.</h6>
                  <hr />
              </Col>
          </Row>
          <Row>
              <Col md={7} mdOffset={3}>
                  <FormGroup>
                      {(this.state.agreeError === null) ? (
                          <Checkbox
                              className="valid"
                              id="agree"
                              number="agree"
                              label="I have reviewed and agree to the Terms and Conditions listed above."
                              value={this.state.agree}
                              onChange={this.handleAgreeCheckbox}
                              checked={this.state.agree}
                          />
                          ) : (
                          <Checkbox
                              className="error"
                              id="agree"
                              number="agree"
                              label="I have reviewed and agree to the Terms and Conditions listed above."
                              value={this.state.agree}
                              onChange={this.handleAgreeCheckbox}
                              checked={this.state.agree}
                          />
                      )}
                      {this.state.agreeError}
                  </FormGroup>
              </Col>
          </Row>

        <div className="wizard-finish-button">
          <Button
            bsStyle="info"
            fill
            wd
            onClick={this.saveRegistration}
            pullRight
          >
            Finish
          </Button>
        </div>
        {this.state.alert}
      </div>
    );
  }
}

export default Step3;



// WEBPACK FOOTER //
// ./src/views/Forms/RegisterWizard/Step3.jsx